<template>
  <div id="popup-container" class="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title"> Manage Users </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark color="white">fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container class="assetbar">
      <div style="border: 1px solid rgba(0, 0, 0, 0.12)">
        <div class="filterSection">
        <v-text-field
          v-model="userSearch"
          label="Filter Users By Name Or Email"
          type="text"
          @change="applyUserSearch"
          class="filter-user"
          append-icon="fa-search"
        ></v-text-field>
        <v-select v-if="this.locations.length"
                :items="locations"
                :clearable="true"
                item-text="name"
                item-value="id"
                :placeholder="$globalConfig.APP_NAME === 'senso' ? 'Select Sites' : 'Select Locations'"
                multiple
                small-chips
                class="categories"
                @change="filterUsersByLocations($event)"
                attach
              >
              <template v-slot:selection="{ item, index }">
                <template v-if="index < 2">
                  <v-chip :title="item.name">{{ $gf.truncateText(item.name, 6) }}</v-chip>
                </template>
                <template v-if="index === 2">
                  <v-chip>...</v-chip>
                </template>
              </template>
            </v-select>
              </div>
        <v-expansion-panels accordion v-model="panel" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header
              expand-icon="mdi-menu-down"
              color="grey50"
              class="assigned-user-heading assigned-user-heading2"
              >Assigned Users
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="ml-1"
                    text
                    x-small
                    color="$improve-grey-900"
                    style="width: auto"
                  >
                    <v-icon x-small>fa fa-question</v-icon>
                  </v-btn>
                </template>
                <span
                  >Below you will see all enrolled Users. To un-enrol Users
                  please select them by ticking the<br />
                  box next to their name or use the select all function to
                  select everyone on this page. <br />Complete the process to
                  un-enrol Users before trying to enrol more Users.</span
                >
              </v-tooltip>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-skeleton-loader v-if="loading && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
                    <v-skeleton-loader v-if="loading && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
              <v-data-table
                v-model="selectedUsers"
                :headers="computedHeaders"
                :options.sync="options"
                :server-items-length="serverItemsLength"
                v-show="!loading"
                :items="users"
                item-key="id"
                show-select
                class="enrol-user-list-tbl"
                :footer-props="{
                  'items-per-page-options': [5, 10, 15, 25, 50, 75, 100],
                }"
              ></v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
      <div style="border: 1px solid rgba(0, 0, 0, 0.12)">
        <v-expansion-panels accordion v-model="panel2" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header
              expand-icon="mdi-menu-down"
              color="grey50"
              class="assigned-user-heading assigned-user-heading2"
              >Unassigned Users</v-expansion-panel-header
            >
            <v-expansion-panel-content>
              <v-skeleton-loader v-if="loading2 && isTabletOrDesktop"  type="table" :types="{ 'table-heading': '','table-thead' : 'heading@4' ,'table-row':'text@4' }" class="slider-table"></v-skeleton-loader>
              <v-skeleton-loader v-if="loading2 && !isTabletOrDesktop" type="table" :types="{ 'table-heading': '', 'table-thead' : 'heading@1' ,'table-row':'text@1'}" class="slider-table"></v-skeleton-loader>
              <v-data-table
                v-model="selectedUsers2"
                :headers="computedHeaders"
                :options.sync="unEnrolledOptions"
                :server-items-length="serverUnenrolledItemsLength"
                v-show="!loading2"
                :items="users2"
                item-key="id"
                show-select
                class="enrol-user-list-tbl"
                :footer-props="{
                  'items-per-page-options': [5, 10, 15, 25, 50, 75, 100],
                }"
              ></v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </v-container>
    <v-footer height="68">
      <v-flex px-4 py-4 text-right>
        <v-btn
          v-if="!loading"
          color="grey300"
          class="mr-4 cancel-button"
          @click="closePanel"
          >Cancel</v-btn
        >
        <v-btn v-if="loading" loading></v-btn>
        <v-btn
          v-else
          color="dark-blue"
          class="add-course-button"
          @click="assignUsers"
          >Save Changes</v-btn
        >
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus.js';
import groupAPI from '@/api/group.js';
import userAPI from '@/api/user.js';
export default {
  name: 'UserDetails',
  props: {
    id: {
      type: String,
      default: null,
    },
    panelParams: {
      type: String,
      default: '',
    },
    locations: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      headers: [
        { text: 'First Name', value: 'first_name' },
        { text: 'Surname', value: 'last_name' },
        { text: 'Email', value: 'email' },
      ],
      panel: [0, 1],
      panel2: [0, 1],
      selectedUsers: [],
      options: {},
      unEnrolledOptions: {},
      pagination: {},
      searchParams: '',
      unEnrolledSearchParams: '',
      users: [],
      loading: false,
      successMessage: 'Users Successfully Enrolled.',
      errorMessage: 'Oops, something went wrong!',
      users2: [],
      selectedUsers2: [],
      pagination2: {},
      loading2: false,
      successUnenrollMessage: 'Users Successfully Un-enrolled.',
      EnrollNotification:
        'Unenrolling Users from this group will delete all their progress and completion data permanently. Are you sure you want to proceed?',
      userSearch: '',
      filterLocations: '',
      debounceTimeout: null,
    };
  },
  computed: {
    computedHeaders() {
      let headers = [...this.headers];
      if (this.locations.length) {
        headers.splice(3, 0, { text: `${this.$globalConfig.APP_NAME === 'senso' ? 'Site' : 'Location'}`, value: 'location', sortable: false });
      }
      return headers;
    },
    serverItemsLength: function () {
      return this.pagination.total;
    },
    itemsPerPage: function () {
      return this.pagination.per_page;
    },
    page: function () {
      return this.pagination.current_page;
    },
    params: function () {
      return this.$gf.getQueryString(this.options);
    },
    serverUnenrolledItemsLength: function () {
      return this.pagination2.total;
    },
    UnEnrolledParams: function () {
      return this.$gf.getQueryString(this.unEnrolledOptions);
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
  },
  watch: {
    options: {
      handler() {
        this.getEnrolledUsers();
      },
      deep: true,
    },
    unEnrolledOptions: {
      handler() {
        this.getUnenrolledUsers();
      },
      deep: true,
    },
  },
  mounted() {
    // this.getSelectedUsers();
    //this.setEventBus();
  },
  methods: {
    getUsers() {
      this.loading = true;
      userAPI.getClients(this.params, this.searchParams).then((resp) => {
        this.users = resp.data.data;
        this.pagination = resp.data.meta.pagination;
        this.loading = false;
      });
    },
    getEnrolledUsers() {
      this.loading = true;
      groupAPI
        .getGroupEnrolledUsers(this.id, this.params, this.searchParams)
        .then((resp) => {
          this.users = resp.data.data;
          this.pagination = resp.data.meta.pagination;
          this.loading = false;
          //this.selectedUsers = resp.data.data;
        });
    },
    getUnenrolledUsers() {
      this.loading2 = true;
      groupAPI
        .getGroupUnenrolledUsers(
          this.id,
          this.UnEnrolledParams,
          this.unEnrolledSearchParams
        )
        .then((resp) => {
          this.users2 = resp.data.data;
          this.pagination2 = resp.data.meta.pagination;
          this.loading2 = false;
          this.users2.length == 0
            ? (this.allUsersEnrolled = true)
            : (this.allUsersEnrolled = false);
        });
    },
    getSelectedUsers() {
      groupAPI.getGroup(this.id, '?include=members').then((resp) => {
        //this.selectedUsers = resp.data.data.members.data;
      });
    },
    assignUsers() {
      if (this.processSelectedUsers().length >= 1) {
        this.$snotify.confirm(this.EnrollNotification, {
          backdrop: 0.3,
          buttons: [
            { text: 'Cancel', className: 'toast-cancel-button' },
            {
              text: 'Yes',
              className: 'toast-continue-button',
              action: (toast) => this.processEnrolUsers(toast),
            },
          ],
        });
      } else {
        this.processEnrolUsers();
      }
    },
    processEnrolUsers(toast = '') {
      this.$snotify.remove(toast.id);
      this.loading = true;
      groupAPI
        .assignUsers(
          this.id,
          this.processSelectedUsers(),
          this.processUnassignSelectedUsers()
        )
        .then(() => {
          this.closePanel();
          EventBus.$emit('GROUPS_UPDATED', this.params);
          if (
            this.processSelectedUsers().length > 0 &&
            this.processUnassignSelectedUsers().length > 0
          ) {
            this.$snotify.success(this.successMessage);
          } else if (
            this.processSelectedUsers().length > 0 &&
            this.processUnassignSelectedUsers().length <= 0
          ) {
            this.$snotify.success(this.successUnenrollMessage);
          } else if (
            this.processSelectedUsers().length <= 0 &&
            this.processUnassignSelectedUsers().length >= 0
          ) {
            this.$snotify.success(this.successMessage);
          } else {
            this.$snotify.success(this.successMessage);
          }
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(() => {
          this.$snotify.error(this.errorMessage);
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    processSelectedUsers() {
      let members = [];
      this.selectedUsers.forEach(function (x) {
        members.push(x.id);
      });
      return members;
    },
    processUnassignSelectedUsers() {
      let members = [];
      this.selectedUsers2.forEach(function (x) {
        members.push(x.id);
      });
      return members;
    },
    applyUserSearch() {
      this.createSearchParams();
    },
    //setEventBus() {
    //  EventBus.$on("USER_SELECTED", payload => {
    //    this.selectedUsers = payload.selectedUsers;
    //  });
    //},
    closePanel() {
      this.$emit('closePanel', {});
    },
    filterUsersByLocations(data){
      clearTimeout(this.debounceTimeout);
      this.filterLocations = data.toString();
      this.debounceTimeout = setTimeout(() => {
        this.createSearchParams();
      }, 1000);
    },
    createSearchParams(){
      this.searchParams = '';
      this.unEnrolledSearchParams = '';
      this.options.page = 1;
      this.unEnrolledOptions.page = 1;
      if(this.userSearch){
        this.searchParams +=  '&search=first_name:' +
        this.userSearch + ';last_name:' + this.userSearch+ ';email:' + this.userSearch;

        this.unEnrolledSearchParams += '&search=first_name:' +
              this.userSearch +';last_name:' +
              this.userSearch+ ';email:' + this.userSearch;
      }
      if (this.filterLocations) {
        this.searchParams += '&locations=' + this.filterLocations;
        this.unEnrolledSearchParams += '&locations=' + this.filterLocations;
      }
      this.getEnrolledUsers();
      this.getUnenrolledUsers();
    }
  },
};
</script>
<style>
.v-expansion-panel-header > :not(.v-expansion-panel-header__icon) {
  flex: none;
}
.assetbar {
  height: calc(100% - 150px);
  overflow-y: scroll;
}
.popup-container {
  height: 100%;
}
</style>
